import { render, staticRenderFns } from "./AuthCodeSettings.vue?vue&type=template&id=365684f4"
import script from "./AuthCodeSettings.vue?vue&type=script&lang=js"
export * from "./AuthCodeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports